import React from "react";
import {withStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from "react-number-format";
import {TextField} from "@material-ui/core";

const styles = (theme) => ({
  filterControl: {
    minWidth: 80,
  },
  labelHidden: {
    display: 'none'
  },
  label: {
    transform: 'translate(14px, 10px) scale(0.75) !important'
  },
  input: {
    paddingTop: 26,
    paddingBottom: 11
  },
  inputAdornment: {
    marginTop: 15
  }
});

MoneyInputField.propTypes = {
  value: PropTypes.number,
  currency: PropTypes.object.isRequired,
  onValueChange: PropTypes.func,
  classes: PropTypes.object
};

function MoneyInputField({value = 0, currency, onValueChange = () => {}, classes, ...props}) {

  let amount = value / Math.pow(10, currency.decimalDigits);

  function MoneyFormat(moneyFormatProps) {

    const {inputRef, onChange, ...other} = moneyFormatProps;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              value: values.floatValue
            }
          });
        }}
        thousandSeparator
        isNumericString
      />
    );
  }

  function handleOnChange(e){
    amount = e.target.value;
  }
  function handleOnBlur() {
    onValueChange(amount * Math.pow(10, currency.decimalDigits));
  }

  const inputLabelClasses = {
    root: classes.label
  };

  const inputClasses = {
    input: classes.input
  };
  const inputAdornmentClasses = {
    root: classes.inputAdornment
  };

  return (
    <TextField
      {...props}
      value={amount}
      InputLabelProps={{
        disableAnimation: true,
        shrink: false,
        classes: inputLabelClasses
      }}
      InputProps={{
        classes: inputClasses,
        inputComponent: MoneyFormat,
        startAdornment: <InputAdornment
                          classes={inputAdornmentClasses}
                          position="start">
                          {currency.symbol}
                        </InputAdornment>
      }}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      />
  );
}

export default withStyles(styles)(MoneyInputField);
